import { render, staticRenderFns } from "./modifyPsd.vue?vue&type=template&id=5adaacdf&scoped=true"
import script from "./modifyPsd.vue?vue&type=script&lang=js"
export * from "./modifyPsd.vue?vue&type=script&lang=js"
import style0 from "./modifyPsd.vue?vue&type=style&index=0&id=5adaacdf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5adaacdf",
  null
  
)

export default component.exports